import React from 'react';
import {connect} from "react-redux";
import DateDisplay from "../../Boilerplate/DateDisplay";
import {Button, Card, Col, Divider, Row} from "antd";
import {NavLink} from "react-router-dom";
import Fuse from "fuse.js";
import PropTypes from 'prop-types';
import SearchBox from "../../Boilerplate/SearchBox";
import ExpandedList from "../../Boilerplate/ExpandedList";
import {deleteTask, getTasks} from "../../../actions/tasks";
import UserSmall from "../../Boilerplate/UserSmall";
import {canCreateSub, canDelete} from "../../Boilerplate/permissions";
import {separatorJoin} from "../../Boilerplate/utilities";
import TaskSummary from "./TaskSummary";
import {CodeTag} from "../../Boilerplate/CodeTag";
import {compArr, subdocumentStatusReportSelector, subViewSelector} from "../selectors";
import {setViewPath} from "../../../actions/view";
import {compose} from "redux";
import {withLoading} from "../../Boilerplate/deferLoaderHoc";
import {DeleteButton} from "../DeleteButton";

class TaskList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filterKeys: null,
      filterActive: false,
      statusFilter: null,
      error: null,
    };
  }

  componentDidMount() {
    const { onMount } = this.props;
    if (onMount) onMount();
  }

  setFilter = (phrase) => {
    if (phrase !== '') {
      let { tasks } = this.props;
      tasks = tasks || [];
      const options = {
        keys: [
          'resource.title',
          'resource.question',
          'resource.response',
        ],
        threshold: 0.3,
        id: 'resource.id'
      };
      let fuse = new Fuse(tasks, options);
      this.setState({
        filterKeys: fuse.search(phrase),
        filterActive: true,
      });
    } else {
      this.setState({
        filterKeys: [],
        filterActive: false,
      });
    }
  };

  setFilterCode = (code) => {
    this.setState({
      statusFilter: code
    });
  };

  clearFilterCode = () => {
    this.setFilterCode(null);
  };

  handleGraphClick = (e) => {
    let category = e.name;
    let { statusSummary } = this.props;
    let chosen = statusSummary.find(x => x.key.name === category);
    if (chosen) {
      this.setFilterCode(chosen.key.code);
    }
  };

  static getDerivedStateFromError(error) {
    return {
      error: error
    };
  }

  render() {
    let { tasks, project } = this.props;
    tasks = tasks || [];

    const { error } = this.state;
    if (error) return <pre>{error.toString()}</pre>;

    const { filterKeys, filterActive, statusFilter } = this.state;
    if (statusFilter) {
      tasks = tasks.filter(task => task.resource.status === statusFilter);
    }
    if (filterActive) {
      tasks = tasks.filter(item => filterKeys.includes(item.resource.id));
    }

    let index = tasks.map(i=>i.resource);
    index.sort((a, b) => a.datecreated-b.datecreated);
    index = index.map(i=>i.id);

    return (
      <React.Fragment>
        <Row gutter={16}>
          <Col span={18}>
            <Card>
              <div className="bid-listing-header">
                <h1>Tasks</h1>
                <SearchBox
                  className='control-box control-search'
                  placeholder='search tasks'
                  onChange={value => this.setFilter(value)}
                />
              </div>
              <Divider/>
              <ExpandedList
                items={tasks}
                index={index}
                derivedKey={item => item.resource.id}
                extra={(<Button type='primary' icon='plus' disabled={!canCreateSub('task')(project)} onClick={this.props.onNew}>New Task</Button>)}
                subExtra={<div>
                  {statusFilter && <Button className={'clear-filter'} size="small" onClick={this.clearFilterCode}>Clear Status Filter</Button>}
                </div>}
                renderHeading={() => (
                  <Row className='bid-listing-heading text-column'>
                    <Col span={10}>Task</Col>
                    <Col span={3}>Created Date</Col>
                    <Col span={6}>Due Date</Col>
                    <Col span={5}>Status</Col>
                  </Row>
                )}
                renderTop={task => {
                  let options = [];
                  if (canDelete(task)) options.push(<DeleteButton fauxKey={'delete-' + task.resource.id} icon='delete'
                    title='Delete Task' document={task} onDelete={this.props.onDelete} type='task'/>);
                  return (
                    <Row justify='space-between'>
                      <Col span={10}>
                        <NavLink to={task.resource.id}>{'#' + task.resource.number + ' - ' + task.resource.name}</NavLink>
                      </Col>
                      <Col span={3}>
                        <DateDisplay date={task.resource.datecreated}/>
                      </Col>
                      <Col span={6}>
                        <DateDisplay date={task.resource.duedate}/>
                      </Col>
                      <Col span={2}>
                        <CodeTag
                          code={task.resource.status}
                          table={'taskstatus'}
                          onClick={() => this.setFilterCode(task.resource.status)}
                        />
                      </Col>
                      <Col span={3}>
                        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                          <div>
                            {separatorJoin(options, <span> | </span>)}
                          </div>
                        </div>
                      </Col>
                    </Row>
                  )
                }}
                renderContent={task => (
                  <React.Fragment>
                    <p>{task.resource.description}</p>
                    <p>Created by <UserSmall id={task.resource.createdbyuserid}/>&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;Assigned to <UserSmall id={task.resource.owneruserid}/></p>
                  </React.Fragment>
                )}
              />
            </Card>
          </Col>
          <Col span={6}>
            <Card>
              <TaskSummary
                title='Tasks by Status'
                onClick={this.handleGraphClick}
              />
            </Card>
          </Col>
        </Row>
      </React.Fragment>
    );
  }
}

TaskList.propTypes = {
  tasks: PropTypes.arrayOf(PropTypes.object),
  statusSummary: PropTypes.array.isRequired,
};

export default compose(
  connect(
    (state, props) => {
      const project = state.view.data[props.match.params.id];
      const loading = state.view.subview.cache.loading;
      const path = state.view.path;
      const listpath = ['projects', props.match.params.id, 'tasks'];
      if (!compArr(path, listpath) || loading) return { loading: true };
      const tasks = subViewSelector(state, props);
      const statusSummary = subdocumentStatusReportSelector(state, { path: 'tasks', code: 'taskstatus' });
      return { tasks, statusSummary, project };
    },
    (dispatch, props) => ({
      loader: () => {
        dispatch(setViewPath(['projects', props.match.params.id, 'tasks']));
        dispatch(getTasks(props.match.params.id));
      },
      onNew: () => props.history.push(`/projects/${props.match.params.id}/tasks/new`),
      onDelete: (taskId) => dispatch(deleteTask(props.match.params.id, taskId)),
    })),
  withLoading
)(TaskList);



// WEBPACK FOOTER //
// ./src/components/Projects/Tasks/TaskList.js